import AuthenticatedAPIClient from '../lib/AuthenticatedAPIClient';
import { URL } from '../helpers/CustomerEndpoint';
import UserStore from '../stores/UserStore';

const ConsentsService = {
    async getConsentsTemplate () {
        return AuthenticatedAPIClient.get(URL.consentsTemplate);
    },

    async getConsents () {
        const user = UserStore.getCurrent();
        const endpoint = URL.consents.replace('{id}', user.id);
        return AuthenticatedAPIClient.get(endpoint);
    },

    async updateConsents (payload) {
        const user = UserStore.getCurrent();
        const endpoint = URL.consents.replace('{id}', user.id);
        return AuthenticatedAPIClient.post(endpoint, payload);
    },
};

export default ConsentsService;



// WEBPACK FOOTER //
// ./src/services/ConsentsService.js